export function firstByClass(elements: HTMLElement[], className: string) {
	for (const parent of elements) {
		if (parent.classList.contains(className)) {
			return parent;
		}
	}

	return null;
}
